export interface FileWithUrlAndName {
    file: File;
    url: string;
    name: string;
}

/** The tabs of an assembly's page, which `?tab` names. */
export const assemblyTabs = ['Bom', 'Cad', 'Manufacturing', 'Pnp'] as const;

export type AssemblyTabsType = (typeof assemblyTabs)[number];

/** Where an assembly is viewed from: inside a project, or from the assembly pages (with the project, if it has one). */
export type ViewContext =
    | {
          type: 'WithinRfQ';
          rfqId: string;
      }
    | {
          type: 'AssemblyOverview';
          // if we are viewing the assembly from the assembly overview pages and its linked to an RFQ, then the rfqId will be present
          rfqId?: string;
      };
